import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
export function Datenschutz() {
  return <div className="min-h-screen bg-[#f4f2ee] font-sans text-[#1a1a1a] text-[14px]" data-id="element-249">
      <SiteHeader data-id="element-250" />

      <div className="max-w-[900px] mx-auto px-[20px] py-[40px]" data-id="element-251">
        <h1 className="text-[28px] font-bold text-[#1a1a1a] mb-[32px] border-b-[2px] border-[#c8c0b0] pb-[16px]" data-id="element-252">
          Datenschutzerklärung
        </h1>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-253">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-254">
            1. Datenschutz auf einen Blick
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-255">
            Allgemeine Hinweise
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-256">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-257">
            Datenerfassung auf dieser Website
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[12px]" data-id="element-258">
            <strong data-id="element-259">
              Wer ist verantwortlich für die Datenerfassung auf dieser Website?
            </strong>
          </p>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-260">
            Die Datenverarbeitung auf dieser Website erfolgt durch den
            Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
            dieser Website entnehmen.
          </p>

          <p className="text-[14px] leading-[1.7] mb-[12px]" data-id="element-261">
            <strong data-id="element-262">Wie erfassen wir Ihre Daten?</strong>
          </p>
          <p className="text-[14px] leading-[1.7]" data-id="element-263">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
            mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in
            ein Kontaktformular eingeben oder wenn Sie Beiträge im Forum
            verfassen. Andere Daten werden automatisch beim Besuch der Website
            durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten
            (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des
            Seitenaufrufs).
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-264">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-265">
            2. Hosting und Content Delivery Networks (CDN)
          </h2>

          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-266">
            Diese Website wird bei einem externen Dienstleister gehostet
            (Hoster). Die personenbezogenen Daten, die auf dieser Website
            erfasst werden, werden auf den Servern des Hosters gespeichert.
            Hierbei kann es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und
            Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen,
            Websitezugriffe und sonstige Daten, die über eine Website generiert
            werden, handeln.
          </p>

          <p className="text-[14px] leading-[1.7]" data-id="element-267">
            Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung
            gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1
            lit. b DSGVO) und im Interesse einer sicheren, schnellen und
            effizienten Bereitstellung unseres Online-Angebots durch einen
            professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-268">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-269">
            3. Allgemeine Hinweise und Pflichtinformationen
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-270">
            Datenschutz
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-271">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
            Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
            vertraulich und entsprechend der gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-272">
            Hinweis zur verantwortlichen Stelle
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[12px]" data-id="element-273">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist:
          </p>
          <div className="bg-[#f9f9f7] border border-[#e0ddd8] rounded-[4px] p-[16px] mb-[16px]" data-id="element-274">
            <p className="text-[14px] leading-[1.7]" data-id="element-275">
              Emerald Health Solutions Ltd.
              <br data-id="element-276" />
              Unit 12, Business Centre, Sandyford
              <br data-id="element-277" />
              Dublin 18, D18 X2P9, Irland
              <br data-id="element-278" />
              <br data-id="element-279" />
              Telefon: +353 1 496 0123
              <br data-id="element-280" />
              E-Mail: contact@emerald-health.ie
            </p>
          </div>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-281">
            Widerruf Ihrer Einwilligung zur Datenverarbeitung
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-282">
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
            Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
            jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per
            E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
            Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-283">
            Beschwerderecht bei der zuständigen Aufsichtsbehörde
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-284">
            Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
            Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
            Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
            oder des Orts des mutmaßlichen Verstoßes zu.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-285">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-286">
            4. Datenerfassung auf dieser Website
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-287">
            Cookies
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-288">
            Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind
            kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an.
            Sie werden entweder vorübergehend für die Dauer einer Sitzung
            (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem
            Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs
            automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät
            gespeichert, bis Sie diese selbst löschen oder eine automatische
            Löschung durch Ihren Webbrowser erfolgt.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-289">
            Server-Log-Dateien
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-290">
            Der Provider der Seiten erhebt und speichert automatisch
            Informationen in so genannten Server-Log-Dateien, die Ihr Browser
            automatisch an uns übermittelt. Dies sind:
          </p>
          <ul className="list-disc list-inside space-y-[6px] text-[14px] leading-[1.7] mb-[16px] ml-[16px]" data-id="element-291">
            <li data-id="element-292">Browsertyp und Browserversion</li>
            <li data-id="element-293">Verwendetes Betriebssystem</li>
            <li data-id="element-294">Referrer URL</li>
            <li data-id="element-295">Hostname des zugreifenden Rechners</li>
            <li data-id="element-296">Uhrzeit der Serveranfrage</li>
            <li data-id="element-297">IP-Adresse</li>
          </ul>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-298">
            Kontaktformular
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-299">
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden
            Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
            angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
            Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
            nicht ohne Ihre Einwilligung weiter.
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-300">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-301">
            5. Ihre Rechte
          </h2>

          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-302">
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
            Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
            erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
            Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
            Datenverarbeitung erteilt haben, können Sie diese Einwilligung
            jederzeit für die Zukunft widerrufen.
          </p>

          <p className="text-[14px] leading-[1.7]" data-id="element-303">
            Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
            sich jederzeit unter der im Impressum angegebenen Adresse an uns
            wenden.
          </p>
        </div>

        <div className="bg-[#fff9e6] border border-[#e8c84a] rounded-[6px] p-[20px]" data-id="element-304">
          <p className="text-[12px] text-[#666] leading-[1.6]" data-id="element-305">
            <strong data-id="element-306">Stand:</strong> April 2026
          </p>
        </div>
      </div>

      <SiteFooter data-id="element-307" />
    </div>;
}